import { render, staticRenderFns } from "./DemoStatistics.vue?vue&type=template&id=0d9592d4&"
import script from "./DemoStatistics.vue?vue&type=script&lang=ts&"
export * from "./DemoStatistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d9592d4')) {
      api.createRecord('0d9592d4', component.options)
    } else {
      api.reload('0d9592d4', component.options)
    }
    module.hot.accept("./DemoStatistics.vue?vue&type=template&id=0d9592d4&", function () {
      api.rerender('0d9592d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DemoStatistics.vue"
export default component.exports